import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { WidgetsModule } from '../widgets/widgets.module';
import { PipesModule } from '../pipes/pipes.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MatMenuModule } from '@angular/material/menu';
import { HeaderDirective } from './header.directive';
import { PermissionEditComponent } from './permission-edit/permission-edit.component';
import { DossierExportDialogComponent } from './dossier-export-dialog/dossier-export-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchMenuModule } from '../widgets/search-menu/search-menu.module';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { LoaderComponent } from "./loader-overlay/loader.component";
import { FocusAreaDirective } from './focus-area.directive';
import { ReduceMotionDirective } from "./directives/reduce-motion.directive";

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    LoaderComponent,
    HeaderDirective,
    FocusAreaDirective,
    PermissionEditComponent,
    DossierExportDialogComponent,
    ReduceMotionDirective
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    HeaderDirective,
    FocusAreaDirective,
    DossierExportDialogComponent,
    PermissionEditComponent,
    ReduceMotionDirective
  ],
  providers: [],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    NgScrollbarModule,
    MatSnackBarModule,
    WidgetsModule,
    PipesModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatCheckboxModule,
    SearchMenuModule,
    MatProgressBarModule,
  ],
})
export class CommonSilberflussModule { }
